var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ActionBtn',{attrs:{"icon":"$transfer","text":_vm.$t('modal.transfer')},nativeOn:{"click":function($event){return _vm.$emit('open-transfer-popup')}}})}
var staticRenderFns = []

export { render, staticRenderFns }